import { searchSiteModel } from '../models/domains.model';

export const searchSites: Array<searchSiteModel> = [
  {
    name: 'Google',
    url: 'google.com'
  },
  {
    name: 'Bing',
    url: 'bing.com'
  },
  {
    name: 'Yahoo',
    url: 'yahoo.com'
  },
  {
    name: 'Ask',
    url: 'ask.com'
  },
  {
    name: 'Baidu',
    url: 'baidu.com'
  },
  {
    name: 'Yandex',
    url: 'yandex.com'
  },
  {
    name: 'blekko',
    url: 'blekko.com'
  },
  {
    name: 'Ixquick',
    url: 'ixquick.com'
  },
  {
    name: 'Startpage',
    url: 'startpage.com'
  },
  {
    name: 'DuckDuckGo',
    url: 'duckduckgo.com'
  },
  {
    name: 'Dogpile',
    url: 'dogpile.com'
  },
  {
    name: 'Excite',
    url: 'excite.com'
  },
  {
    name: 'AltaVista',
    url: 'altavista.com'
  },
  {
    name: 'Teoma',
    url: 'teoma.com'
  },
  {
    name: 'Hakia',
    url: 'hakia.com'
  },
  {
    name: 'AOL Search',
    url: 'search.aol.com'
  },
  {
    name: 'Lycos',
    url: 'lycos.com'
  },
  {
    name: 'Active Search Results',
    url: 'activesearchresults.com'
  },
  {
    name: 'Apexoo',
    url: 'apexoo.com'
  },
  {
    name: 'Blackle',
    url: 'blackle.com'
  },
  {
    name: 'Cluuz',
    url: 'cluuz.com'
  },
  {
    name: 'CompuServe Search',
    url: 'webcenters.netscape.compuserve.com/search/default.jsp'
  },
  {
    name: 'Entireweb',
    url: 'entireweb.com'
  },
  {
    name: 'Exalead',
    url: 'exalead.com/search'
  },
  {
    name: 'Hotbot',
    url: 'hotbot.com'
  },
  {
    name: 'Lexxe',
    url: 'lexxe.com'
  },
  {
    name: 'Mojeek',
    url: 'mojeek.com'
  },
  {
    name: 'Scrub The Web',
    url: 'scrubtheweb.com'
  },
  {
    name: 'SeekFu',
    url: 'seekfu.com'
  },
  {
    name: 'Visvo',
    url: 'visvo.com'
  },
  {
    name: 'Yippy ',
    url: 'yippy.com'
  },
  {
    name: 'BioMed Search',
    url: 'biomed-search.com'
  },
  {
    name: 'Infomine',
    url: 'infomine.ucr.edu'
  },
  {
    name: 'Intute',
    url: 'intute.ac.uk'
  },
  {
    name: 'ipl2',
    url: 'ipl.org'
  },
  {
    name: 'NihilScio',
    url: 'nihilscio.it'
  },
  {
    name: 'OmniMedicalSearch',
    url: 'omnimedicalsearch.com'
  },
  {
    name: 'Q-Sensei',
    url: 'lambda.qsensei.com'
  },
  {
    name: 'Quertle',
    url: 'quertle.info'
  },
  {
    name: 'RefSeek',
    url: 'refseek.com'
  },
  {
    name: 'Scirus',
    url: 'scirus.com'
  },
  {
    name: 'SearchMedia',
    url: 'searchmedica.co.uk'
  },
  {
    name: 'Sweetsearch',
    url: 'sweetsearch.com'
  },
  {
    name: 'Vadlo',
    url: 'vadlo.com'
  },
  {
    name: 'Virtual Learning Resources Cente',
    url: 'virtuallrc.com'
  },
  {
    name: 'FindSounds',
    url: 'findsounds.com'
  },
  {
    name: 'RadioScout',
    url: 'radioscout.org'
  },
  {
    name: 'Icerocket',
    url: 'icerocket.com'
  },
  {
    name: 'MagPortal',
    url: 'magportal.com'
  },
  {
    name: 'NewsLookup.com',
    url: 'newslookup.com'
  },
  {
    name: 'Silobreaker',
    url: 'silobreaker.com'
  },
  {
    name: 'Technorati',
    url: 'technorati.com'
  },
  {
    name: 'eBook Search Queen',
    url: 'ebook-search-queen.com'
  },
  {
    name: 'Find PDF',
    url: 'pdffinder.net'
  },
  {
    name: 'Foofind',
    url: 'foofind.is'
  },
  {
    name: 'PDF Science Search',
    url: 'weblib.in.ua'
  },
  {
    name: 'PPT Search 365',
    url: 'pptsearch365.com'
  },
  {
    name: 'PrintFu',
    url: 'printfu.org'
  },
  {
    name: 'SlideFinder',
    url: 'slidefinder.net'
  },
  {
    name: 'Panjoy',
    url: 'panjoy.com'
  },
  {
    name: 'RecipeBridge',
    url: 'recipebridge.com'
  },
  {
    name: 'Yummly',
    url: 'yummly.com'
  },
  {
    name: 'Boardreader',
    url: 'boardreader.com'
  },
  {
    name: 'Omgili',
    url: 'omgili.com'
  },
  {
    name: 'Incogna',
    url: 'incogna.com'
  },
  {
    name: 'Macroglossa',
    url: 'macroglossa.com'
  },
  {
    name: 'Picsearch',
    url: 'picsearch.com'
  },
  {
    name: 'Quality Image Search',
    url: 'qualityimagesearch.com'
  },
  {
    name: 'Behold',
    url: 'behold.cc'
  },
  {
    name: 'Compfight',
    url: 'compfight.com'
  },
  {
    name: 'Digital Inspiration: Search Pictures on Flickr, MySpace, Facebook ..',
    url: 'labnol.org/image-search'
  },
  {
    name: 'PicFog',
    url: 'picfog.com'
  },
  {
    name: 'Pixolu2',
    url: 'pixolu.de'
  },
  {
    name: 'Twicsy',
    url: 'twicsy.com'
  },
  {
    name: 'Twipho',
    url: 'twipho.net'
  },
  {
    name: 'Webstagram',
    url: 'web.stagram.com'
  },
  {
    name: 'everystockphoto',
    url: 'everystockphoto.com'
  },
  {
    name: 'PicFindr',
    url: 'picfindr.com'
  },
  {
    name: 'Facesaerch',
    url: 'facesaerch.com'
  },
  {
    name: 'imense picturesearch',
    url: 'picturesearch.imense.com'
  },
  {
    name: 'TinEye Reverse Image Search',
    url: 'tineye.com'
  },
  {
    name: 'Vector.us',
    url: 'vector.us'
  },
  {
    name: 'Find Icons',
    url: 'findicons.com'
  },
  {
    name: 'Icon Seeker',
    url: 'iconseeker.com'
  },
  {
    name: 'Iconfinder',
    url: 'iconfinder.com'
  },
  {
    name: 'iconlet',
    url: 'iconlet.com'
  },
  {
    name: 'IconsPedia',
    url: 'iconspedia.com'
  },
  {
    name: 'Icons-Search',
    url: 'icons-search.com'
  },
  {
    name: 'Very Icon',
    url: 'veryicon.com'
  },
  {
    name: 'oSkope',
    url: 'oskope.com'
  },
  {
    name: 'Blinkx',
    url: 'blinkx.com'
  },
  {
    name: 'CastTV',
    url: 'casttv.com'
  },
  {
    name: 'Clipflakes.tv',
    url: 'clipflakes.tv'
  },
  {
    name: 'Trooker',
    url: 'trooker.com'
  },
  {
    name: 'IFACnet',
    url: 'ifacnet.com'
  },
  {
    name: 'Lexis Web',
    url: 'lexisweb.com'
  },
  {
    name: 'Simply Hired',
    url: 'simplyhired.com'
  },
  {
    name: 'WebC-I',
    url: 'webc-i.com'
  },
  {
    name: '123 people',
    url: '123people.com'
  },
  {
    name: 'iSearch',
    url: 'isearch.com'
  },
  {
    name: 'Lullar',
    url: 'com.lullar.com'
  },
  {
    name: 'PeekYou',
    url: 'peekyou.com'
  },
  {
    name: 'Pipl',
    url: 'pipl.com'
  },
  {
    name: 'Spokeo',
    url: 'spokeo.com'
  },
  {
    name: 'Sysoon',
    url: 'sysoon.com'
  },
  {
    name: 'Wink',
    url: 'wink.com'
  },
  {
    name: 'zoominfo',
    url: 'zoominfo.com'
  },
  {
    name: 'Goonux',
    url: 'goonux.cristalys.com/fr/index_en.php3'
  },
  {
    name: 'merobase',
    url: 'merobase.com'
  },
  {
    name: 'Roozzy',
    url: 'roozzy.com'
  },
  {
    name: 'RSSsearchhub',
    url: 'rsssearchhub.com'
  },
  {
    name: 'Search[code]',
    url: 'searchco.de'
  },
  {
    name: 'SearchIRC',
    url: 'searchirc.com'
  },
  {
    name: 'Shodan',
    url: 'shodanhq.com'
  },
  {
    name: 'SurfWax',
    url: 'surfwax.com'
  },
  {
    name: 'Swoogle',
    url: 'swoogle.umbc.edu'
  },
  {
    name: 'sengine.info',
    url: 'sengine.info'
  },
  {
    name: 'Thunderstone',
    url: 'search.thunderstone.com/texis/websearch'
  },
  {
    name: 'ColorOf',
    url: 'colorof.com'
  },
  {
    name: 'Ecofreek',
    url: 'ecofreek.com'
  },
  {
    name: 'eudict.eu',
    url: 'eudict.eu'
  },
  {
    name: 'Factbites',
    url: 'factbites.com'
  },
  {
    name: 'FAROO',
    url: 'faroo.com'
  },
  {
    name: 'Google minus Google',
    url: 'startupbin.com/google-google'
  },
  {
    name: 'Green Maven',
    url: 'greenmaven.com'
  },
  {
    name: 'QueryCAT',
    url: 'querycat.com'
  },
  {
    name: 'Seeks',
    url: 'seeks-project.info'
  },
  {
    name: 'SeeSources.com',
    url: 'seesources.com'
  },
  {
    name: 'Snappyfingers ',
    url: 'snappyfingers.com'
  },
  {
    name: 'Stylig',
    url: 'stylig.com'
  },
  {
    name: 'Tripat.de',
    url: 'tripat.de'
  },
  {
    name: 'Zanran',
    url: 'zanran.com'
  },
  {
    name: 'Ecosia',
    url: 'ecosia.org'
  },
  {
    name: 'Everyclick',
    url: 'everyclick.com'
  },
  {
    name: 'GoodSearch',
    url: 'goodsearch.com'
  },
  {
    name: 'Ripple',
    url: 'ripple.org'
  },
  {
    name: 'Similar Pages',
    url: 'similarpages.com'
  },
  {
    name: 'Similar Site Search',
    url: 'similarsitesearch.com'
  },
  {
    name: 'Similicio.us',
    url: 'similicio.us'
  },
  {
    name: 'SitesLikeSites',
    url: 'siteslikesites.com'
  },
  {
    name: 'AnooX',
    url: 'anoox.com'
  },
  {
    name: 'Fooxx',
    url: 'fooxx.com'
  },
  {
    name: 'SearchTeam',
    url: 'searchteam.com'
  },
  {
    name: 'Slikk',
    url: 'slikk.com'
  },
  {
    name: 'Sency',
    url: 'sency.com'
  },
  {
    name: 'Social Searcher',
    url: 'social-searcher.com'
  },
  {
    name: 'Spezify',
    url: 'spezify.com'
  },
  {
    name: 'Tinker',
    url: 'tinker.com'
  },
  {
    name: 'Topsy',
    url: 'topsy.com'
  },
  {
    name: 'Twitority',
    url: 'twithority.com'
  },
  {
    name: 'ApocalX',
    url: 'search.apocalx.net'
  },
  {
    name: 'Apollo7',
    url: 'apollo7.co.uk'
  },
  {
    name: 'Carrot2',
    url: 'search.carrot2.org'
  },
  {
    name: 'Cosmoage',
    url: 'cosmoage.com'
  },
  {
    name: 'Devilfinder',
    url: 'devilfinder.com'
  },
  {
    name: 'eLocalFinder',
    url: 'elocalfinder.com/HSearch.aspx'
  },
  {
    name: 'Finday',
    url: 'finday.com'
  },
  {
    name: 'Forelook ',
    url: 'forelook.com'
  },
  {
    name: 'FuzzFind',
    url: 'fuzzfind.com'
  },
  {
    name: 'Geegain',
    url: 'geegain.com'
  },
  {
    name: 'GoKookyGo',
    url: 'gokookygo.net'
  },
  {
    name: 'Goofram ',
    url: 'goofram.com'
  },
  {
    name: 'Gopher',
    url: 'gopher.com'
  },
  {
    name: 'Harvester42',
    url: 'harvester42.fzk.de/jss/Harvester42'
  },
  {
    name: 'I Net Monster',
    url: 'inetmonster.com'
  },
  {
    name: 'iBoogie',
    url: 'iboogie.com'
  },
  {
    name: 'Info.com',
    url: 'info.com'
  },
  {
    name: 'Iseek',
    url: 'iseek.com'
  },
  {
    name: 'LookAllWeb',
    url: 'lookallweb.com'
  },
  {
    name: 'Mamma',
    url: 'mamma.com'
  },
  {
    name: 'Metabear',
    url: 'metabear.ru'
  },
  {
    name: 'MetaCrawler',
    url: 'metacrawler.com'
  },
  {
    name: 'Monstercrawler',
    url: 'monstercrawler.com'
  },
  {
    name: 'OpenText Federated Query Server',
    url: 'fqs.opentext.com/web.htm'
  },
  {
    name: 'PolyMeta',
    url: 'polymeta.com'
  },
  {
    name: 'Qrobe',
    url: 'qrobe.it'
  },
  {
    name: 'Roysearch',
    url: 'roysearch.com'
  },
  {
    name: 'Scandoo',
    url: 'scandoo.com'
  },
  {
    name: 'Search',
    url: 'search.com'
  },
  {
    name: 'Searches',
    url: 'searches.com'
  },
  {
    name: 'Sgyba',
    url: 'sgyba.com'
  },
  {
    name: 'Sperse',
    url: 'sperse.com'
  },
  {
    name: 'Squikoo',
    url: 'squikoo.com'
  },
  {
    name: 'Stinky Teddy',
    url: 'stinkyteddy.com'
  },
  {
    name: 'Turboscout',
    url: 'turboscout.com'
  },
  {
    name: 'WebCrawler',
    url: 'webcrawler.com'
  },
  {
    name: 'Webfetch',
    url: 'webfetch.com'
  },
  {
    name: 'WebNocular',
    url: 'webnocular.com'
  },
  {
    name: 'Yometa ',
    url: 'yometa.com'
  },
  {
    name: 'Zapmeta',
    url: 'zapmeta.com'
  },
  {
    name: 'Search Nigeria',
    url: 'searchnigeria.net'
  },
  {
    name: '258.com',
    url: '258.com'
  },
  {
    name: '2881.com',
    url: '2881.com'
  },
  {
    name: 'Antso.cn',
    url: 'antso.cn'
  },
  {
    name: 'Sogou',
    url: 'sogou.com'
  },
  {
    name: 'Soso',
    url: 'soso.com'
  },
  {
    name: 'Youdao',
    url: 'youdao.com'
  },
  {
    name: 'ZhongSou.com',
    url: 'zhongsou.com'
  },
  {
    name: 'Biglobe',
    url: 'biglobe.ne.jp'
  },
  {
    name: 'Ceek.jp',
    url: 'ceek.jp'
  },
  {
    name: 'Fresheye',
    url: 'fresheye.com'
  },
  {
    name: 'Goo',
    url: 'goo.ne.jp'
  },
  {
    name: 'Metcha Search',
    url: 'bach.istc.kobe-u.ac.jp/metcha'
  },
  {
    name: 'Spysee',
    url: 'spysee.jp'
  },
  {
    name: 'Daum',
    url: 'daum.net'
  },
  {
    name: 'Nate',
    url: 'nate.com'
  },
  {
    name: 'Naver',
    url: 'naver.com'
  },
  {
    name: 'simmani.com',
    url: 'simmani.com'
  },
  {
    name: 'Alleba',
    url: 'alleba.com'
  },
  {
    name: 'Rediff',
    url: 'rediff.com'
  },
  {
    name: 'sify.com',
    url: 'sify.com'
  },
  {
    name: 'Ilse',
    url: 'ilse.nl'
  },
  {
    name: 'Jaan.be ',
    url: 'jaan.be'
  },
  {
    name: 'Metaseek',
    url: 'metaseek.nl'
  },
  {
    name: 'Vinden.nl',
    url: 'vinden.nl'
  },
  {
    name: 'Zoek.nl',
    url: 'zoek.nl'
  },
  {
    name: 'BabyGo',
    url: 'babygo.fr'
  },
  {
    name: 'Doona',
    url: 'doona.fr'
  },
  {
    name: 'Echonimo',
    url: 'echonimo.com'
  },
  {
    name: 'Infoseek',
    url: 'infoseek.fr'
  },
  {
    name: 'Seek.fr',
    url: 'seek.fr'
  },
  {
    name: 'Toile du Qu\u00e9bec',
    url: 'toile.com'
  },
  {
    name: 'Vatrouver',
    url: 'vatrouver.com'
  },
  {
    name: 'Vigoos',
    url: 'vigoos.com'
  },
  {
    name: 'Voila',
    url: 'voila.fr'
  },
  {
    name: '\u00d6ko-Anbieter.de',
    url: 'oeko-anbieter.de'
  },
  {
    name: 'Acoon',
    url: 'acoon.de'
  },
  {
    name: 'AlleFragen.net',
    url: 'allefragen.net'
  },
  {
    name: 'BASE: Bielefeld Academic Search',
    url: 'base-search.net'
  },
  {
    name: 'Blinde Kuh',
    url: 'blinde-kuh.de'
  },
  {
    name: 'Clewwa',
    url: 'clewwa.de'
  },
  {
    name: 'Deligoo',
    url: 'deligoo.de'
  },
  {
    name: 'DeutscheSeiten.de',
    url: 'deutscheseiten.de'
  },
  {
    name: 'Die Kraehe',
    url: 'die-kraehe.de'
  },
  {
    name: 'DigiBib',
    url: 'digibib.net/Digibib?LOCATION=361'
  },
  {
    name: 'Discounto',
    url: 'discounto.de'
  },
  {
    name: 'Fastbot',
    url: 'fastbot.de'
  },
  {
    name: 'Financiero.de',
    url: 'financiero.de'
  },
  {
    name: 'Fireball',
    url: 'fireball.de'
  },
  {
    name: 'InfoWeb Weiterbildung - IWWB',
    url: 'iwwb.de'
  },
  {
    name: 'Lixam.de',
    url: 'lixam.de'
  },
  {
    name: 'MetaGer',
    url: 'metager.de'
  },
  {
    name: 'Metager2',
    url: 'metager2.de'
  },
  {
    name: 'MetaScroll ',
    url: 'metascroll.com'
  },
  {
    name: 'Metaspinner',
    url: 'index.meta-spinner.de'
  },
  {
    name: 'Meteora',
    url: 'meteora.de'
  },
  {
    name: 'Ministerien.net',
    url: 'ministerien.net'
  },
  {
    name: 'Netluchs.de',
    url: 'netluchs.de'
  },
  {
    name: 'OneSeek.de',
    url: 'oneseek.de'
  },
  {
    name: 'Qualigo',
    url: 'qualigo.de'
  },
  {
    name: 'Semager',
    url: 'semager.de'
  },
  {
    name: 'Suchen.de',
    url: 'suchen.de'
  },
  {
    name: 'T-Online',
    url: 't-online.de'
  },
  {
    name: 'Vebidoo',
    url: 'vebidoo.de'
  },
  {
    name: 'VS-Maschinenbau',
    url: 'vs-maschinenbau.de'
  },
  {
    name: 'Yabado',
    url: 'yabado.de'
  },
  {
    name: 'yasni.de',
    url: 'yasni.de'
  },
  {
    name: 'ETools.ch',
    url: 'etools.ch'
  },
  {
    name: 'Search.ch',
    url: 'search.ch'
  },
  {
    name: 'AnazitisiS',
    url: 'anazitisis.gr'
  },
  {
    name: 'Ano-Kato',
    url: 'ano-kato.com'
  },
  {
    name: 'Visto',
    url: 'visto.gr'
  },
  {
    name: 'Aristotele',
    url: 'aristotele.net'
  },
  {
    name: 'Gjlg Metamotore',
    url: 'gjlg.com'
  },
  {
    name: 'Il Trovatore',
    url: 'iltrovatore.it'
  },
  {
    name: 'Iusseek',
    url: 'iusseek.com'
  },
  {
    name: 'Libero - Ricerca',
    url: 'arianna.libero.it'
  },
  {
    name: 'Virgilio',
    url: 'virgilio.it'
  },
  {
    name: 'Volunia',
    url: 'volunia.com'
  },
  {
    name: 'Webtracer',
    url: 'arcano.net'
  },
  {
    name: 'Eniro',
    url: 'eniro.se'
  },
  {
    name: 'Jubii',
    url: 'soeg.jubii.dk'
  },
  {
    name: 'Seek.se',
    url: 'seek.se'
  },
  {
    name: 'Elisa.Net',
    url: 'elisa.net'
  },
  {
    name: 'Leit.is',
    url: 'leit.is'
  },
  {
    name: 'diri',
    url: 'diri.bg'
  },
  {
    name: 'Jabse',
    url: 'jabse.com'
  },
  {
    name: 'Jyxo',
    url: 'jyxo.cz'
  },
  {
    name: 'Kl\u00e1bosen\u00ed.cz',
    url: 'klaboseni.cz'
  },
  {
    name: 'Seznam',
    url: 'seznam.cz'
  },
  {
    name: 'F\u00f3rumkeres\u0151',
    url: 'forumkereso.hu'
  },
  {
    name: 'Gizike.hu',
    url: 'gizike.hu'
  },
  {
    name: 'Johu',
    url: 'johu.hu'
  },
  {
    name: 'Lapozz.hu',
    url: 'lapozz.hu'
  },
  {
    name: 'Ok.hu',
    url: 'ok.hu'
  },
  {
    name: 'WYW kereso',
    url: 'kereso.wyw.hu'
  },
  {
    name: 'Delfi',
    url: 'search.delfi.lt'
  },
  {
    name: 'Gooru.pl',
    url: 'gooru.pl'
  },
  {
    name: 'Netsprint',
    url: 'netsprint.pl'
  },
  {
    name: 'Username.ro',
    url: 'username.ro'
  },
  {
    name: 'Srpko',
    url: 'srpko.com'
  },
  {
    name: 'Morfeo',
    url: 'morfeo.sk'
  },
  {
    name: 'Najdi.si',
    url: 'najdi.si'
  },
  {
    name: 'Buscar',
    url: 'buscar.com.br'
  },
  {
    name: 'IOL',
    url: 'iol.pt'
  },
  {
    name: 'Sapo',
    url: 'sapo.pt'
  },
  {
    name: 'Site de Busca',
    url: 'sitedebusca.com'
  },
  {
    name: 'UOL Busca',
    url: 'busca.uol.com.br'
  },
  {
    name: 'HispaVista',
    url: 'hispavista.com'
  },
  {
    name: 'Laiesken',
    url: 'laiesken.net'
  },
  {
    name: 'Terra',
    url: 'terra.com'
  },
  {
    name: 'Xaarky Metabuscador',
    url: 'xaarky.es'
  },
  {
    name: 'Enxogo',
    url: 'enxogo.com'
  },
  {
    name: 'Huubs',
    url: 'huubs.imente.com'
  },
  {
    name: '1el.ru',
    url: '1el.ru'
  },
  {
    name: 'Agropoisk.ru',
    url: 'agropoisk.ru'
  },
  {
    name: 'Bukinist',
    url: 'bukinist.agava.ru'
  },
  {
    name: 'Codavr.ru',
    url: 'codavr.ru'
  },
  {
    name: 'go.mail.ru',
    url: 'go.mail.ru'
  },
  {
    name: 'ljpoisk.ru',
    url: 'ljpoisk.ru'
  },
  {
    name: 'MetaBot.ru',
    url: 'metabot.ru'
  },
  {
    name: 'MetaBrain',
    url: 'metabrain.ru'
  },
  {
    name: 'nigma.ru',
    url: 'nigma.ru'
  },
  {
    name: 'Rambler',
    url: 'rambler.ru'
  },
  {
    name: 'Yottos',
    url: 'yottos.ru'
  },
  {
    name: 'Yamli',
    url: 'yamli.com'
  },
  {
    name: 'Behjoo',
    url: 'behjoo.com'
  },
  {
    name: 'Jamasp',
    url: 'jamasp.com'
  },
  {
    name: 'Parseek',
    url: 'parseek.com'
  },
  {
    name: 'Walla!',
    url: 'walla.co.il'
  },
  {
    name: 'Web Wombat',
    url: 'webwombat.com.au'
  },
  {
    name: 'Ansearch ',
    url: 'ansearch.com'
  },
  {
    name: 'DeeperWeb',
    url: 'deeperweb.com'
  },
  {
    name: 'Exactseek',
    url: 'exactseek.com'
  },
  {
    name: 'Findelio',
    url: 'findelio.com'
  },
  {
    name: 'Geona',
    url: 'geona.com'
  },
  {
    name: 'Gigablast',
    url: 'gigablast.com'
  },
  {
    name: 'Heapr ',
    url: 'heapr.com'
  },
  {
    name: 'KidRex',
    url: 'kidrex.org'
  },
  {
    name: 'ManagedQ',
    url: 'managedq.com'
  },
  {
    name: 'Mundusearch ',
    url: 'mundusearch.com'
  },
  {
    name: 'MyAllSearch',
    url: 'myallsearch.com'
  },
  {
    name: 'MyWebSearch',
    url: 'home.mywebsearch.com'
  },
  {
    name: 'Oolone',
    url: 'oolone.com'
  },
  {
    name: 'Pepesearch',
    url: 'pepesearch.com'
  },
  {
    name: 'Pesquisar.org',
    url: 'pesquisar.org'
  },
  {
    name: 'Redz',
    url: 'redz.com'
  },
  {
    name: 'Scour',
    url: 'scour.com'
  },
  {
    name: 'Search66',
    url: 'search66.com'
  },
  {
    name: 'Searchhippo',
    url: 'searchhippo.com'
  },
  {
    name: 'Slider',
    url: 'slider.com'
  },
  {
    name: 'Spacetime 3D',
    url: 'search.spacetime.com'
  },
  {
    name: 'Surfcanyon ',
    url: 'surfcanyon.com'
  },
  {
    name: 'The Net 1',
    url: 'thenet1.com'
  },
  {
    name: 'Agent 55',
    url: 'agent55.com'
  },
  {
    name: 'Askboth',
    url: 'askboth.com'
  },
  {
    name: 'Blindsearch',
    url: 'blindsearch.fejus.com'
  },
  {
    name: 'Draze',
    url: 'draze.com'
  },
  {
    name: 'Giapeto',
    url: 'giapeto.com'
  },
  {
    name: 'GrabAll',
    url: 'graball.com'
  },
  {
    name: 'ManyGet',
    url: 'manyget.com'
  },
  {
    name: 'Multi Searching',
    url: 'multisearching.com'
  },
  {
    name: 'Multiple Search',
    url: 'search.io'
  },
  {
    name: 'PolyCola',
    url: 'polycola.com'
  },
  {
    name: 'Search GBY',
    url: 'searchgby.com'
  },
  {
    name: 'Searchboth',
    url: 'us.searchboth.net'
  },
  {
    name: 'SearchEzee',
    url: 'searchezee.com'
  },
  {
    name: 'Seeaarch',
    url: 'seeaarch.com'
  },
  {
    name: 'Targ8',
    url: 'targ8.com'
  },
  {
    name: 'TopSite',
    url: 'topsite.com'
  },
  {
    name: 'trovando.it',
    url: 'trovando.it'
  },
  {
    name: 'Twingine',
    url: 'twingine.com'
  },
  {
    name: 'Wotbox',
    url: 'wotbox.com'
  },
  {
    name: 'Yabigo',
    url: 'yabigo.com'
  },
  {
    name: 'Zuula',
    url: 'zuula.com'
  },
  {
    name: 'Kvasir',
    url: 'kvasir.no'
  },
  {
    name: 'OneLook',
    url: 'onelook.com'
  },
  {
    name: 'Thiv',
    url: 'thiv.net'
  },
  {
    name: 'Soorsa',
    url: 'soorsa.com'
  },
  {
    name: 'moresearch.biz',
    url: 'moresearch.biz'
  },
  {
    name: 'Soku',
    url: 'soku.com'
  },
  {
    name: 'Verbase',
    url: 'verbase.com'
  },
  {
    name: 'InfoSpace',
    url: 'search.infospace.com'
  },
  {
    name: 'Blippex',
    url: 'blippex.org'
  },
  {
    name: 'NerdyData',
    url: 'nerdydata.com'
  },
  {
    name: 'Zeekly',
    url: 'zeekly.com'
  },
  {
    name: 'Qwant',
    url: 'qwant.com'
  },
  {
    name: 'Yam Search',
    url: 'search.yam.com'
  },
  {
    name: 'WbSrch',
    url: 'wbsrch.com'
  },
  {
    name: 'Egerin',
    url: 'egerin.com'
  },
  {
    name: 'Salam',
    url: 'salam.ir'
  },
  {
    name: 'Matcoan',
    url: 'matcoan.pcriot.com'
  },
  {
    name: 'CENTIL - \u00d6sterreich',
    url: 'centil-europe.at'
  },
  {
    name: 'CENTIL - Schweiz',
    url: 'centil-europe.ch'
  },
  {
    name: 'OdiaSearch',
    url: 'odiasearch.com'
  },
  {
    name: 'Squishy Squashy',
    url: 'squishysquashysearch.com'
  },
  {
    name: 'oscobo',
    url: 'oscobo.co.uk'
  },
  {
    name: 'hulbee',
    url: 'hulbee.com'
  },
  {
    name: 'metager',
    url: 'metager.de/en'
  },
  {
    name: 'Wow',
    url: 'wow.com'
  },
  {
    name: 'Alhea',
    url: 'alhea.com'
  },
  {
    name: 'Lilo',
    url: 'search.lilo.org'
  },
  {
    name: 'unbubble',
    url: 'unbubble.eu'
  },
  {
    name: 'Mindworks Free Full-Text Online Law Search Engines',
    url: 'mindworks.alterivsta.org'
  },
  {
    name: 'Zeppy.io',
    url: 'zeppy.io'
  },
  {
    name: 'TravelTime Maps',
    url: 'app.traveltimeplatform.com/#'
  }
];
